import hrNumber from '@/plugins/HumanReadableNumbers'

export default {
    methods: {
        drawChart () {},
        redrawChart () {},
        hasChildren (id, data) {
            return data.filter((datum) => datum.parent === id).length
        },
        destroyComponents (components) {
            if (components.constructor.name === 'Object') {
                for (let component in components) {
                    this.destroyComponents(components[component])
                    components[component] = undefined
                    delete components[component]
                }
            } else {
                if (typeof components.detach === 'function') {
                    components.detach()
                }
                if (typeof components.destroy === 'function') {
                    components.destroy()
                }
            }
        },
        setData (self, data) {
            self.content = data
            self.filter = self.content.filter || null
            self.filterOptions = self.content.filterOptions || []
            self.$nextTick(function () {
                self.drawChart()
            })
        },
        dataZoomIn (self, id) {
            self.dataZoom.push(id)
            self.redrawChart()
        },
        dataZoomOut (self, parent) {
            if (self.dataZoom.length) {
                let oldParent = self.dataZoom.pop()
                if (parent !== undefined) {
                    while (self.dataZoom.length && oldParent !== parent) {
                        oldParent = self.dataZoom.pop()
                    }
                }
                self.redrawChart()
            }
        },
        formatValue (data, parts) {
            let value = ''

            if (!Array.isArray(parts)) {
                if (typeof parts !== 'object') {
                    parts = [{type: 'field', value: parts}]
                } else {
                    parts = [parts]
                }
            }

            for (let part of parts || []) {
                if (part.type === 'field') {
                    value = value + (data[part.value] || '')
                } else if (part.type === 'literal') {
                    value = value + (part.value || '')
                } else if (part.type === 'numberLocalize') {
                    value = value + (data[part.value].toLocaleString('en-US') || '')
                } else if (part.type === 'humanReadable') {
                    value = value + hrNumber(data[part.value.field || part.value] || 0, part.value.maxDigits || 5, part.value.maxDecimal || null)
                }
            }

            return value
        },
        trimRow (row, config) {
            let trimmedRow = {}

            for (var field in config) {
                trimmedRow[field] = this.formatValue(row, config[field].format || field)
            }

            return trimmedRow
        },
        implode (parts, glue) {
            glue = glue || ' '

            return Array.isArray(parts) ? parts.join(glue) : parts
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/ChartMixin.js